import { Route, Switch } from "wouter";

import { BulkExportDetail } from "../features/bulk-exports/bulk-export-detail/bulk-export-detail";
import { BulkExportList } from "../features/bulk-exports/bulk-export-list/bulk-export-list";
import {
  BulkExportClone,
  BulkExportNew,
} from "../features/bulk-exports/bulk-export-new/bulk-export-new";
import { ApiPage } from "../pages/api-page";
import HomePage from "../pages/home-page";
import ImportPage from "../pages/import-page";
import { InfoPage } from "../pages/info-page";
import ScenarioComparisonPage from "../pages/scenario-comparison-page";
import ScenarioDetailMap from "../pages/scenario-detail-map";
import ScenarioDetailPage from "../pages/scenario-detail-page";
import ScenarioPage from "../pages/scenario-page";

export default function Routes() {
  return (
    <Switch>
      <Route path="/scenarios/compare">
        <ScenarioComparisonPage />
      </Route>
      <Route path="/scenarios/:id/map">
        {(params) => <ScenarioDetailMap scenarioIdParam={params.id} />}
      </Route>
      <Route path="/scenarios/:id">
        {(params) => <ScenarioDetailPage scenarioIdParam={params.id} />}
      </Route>
      <Route path="/scenarios">
        <ScenarioPage />
      </Route>

      {/* Scenario Export */}
      <Route path="/export/scenarios">
        <BulkExportList exportType="bulk_file" />
      </Route>
      <Route path="/export/scenarios/new">
        <BulkExportNew exportType="bulk_file" />
      </Route>
      <Route path="/export/scenarios/clone/:id">
        {(params) => <BulkExportClone exportType="bulk_file" clone={params.id} />}
      </Route>
      <Route path="/export/scenarios/:id">
        {(params) => <BulkExportDetail id={params.id} exportType="bulk_file" />}
      </Route>

      {/* Composite Export ('Samengestelde kaarten') */}
      <Route path="/export/composite">
        <BulkExportList exportType="composite_map" />
      </Route>
      <Route path="/export/composite/new">
        <BulkExportNew exportType="composite_map" />
      </Route>
      <Route path="/export/composite/clone/:id">
        {(params) => <BulkExportClone exportType="composite_map" clone={params.id} />}
      </Route>
      <Route path="/export/composite/:id">
        {(params) => <BulkExportDetail id={params.id} exportType="composite_map" />}
      </Route>

      {/* ROR Export */}
      <Route path="/export/ror">
        <BulkExportList exportType="ror" />
      </Route>
      <Route path="/export/ror/new">
        <BulkExportNew exportType="ror" />
      </Route>
      <Route path="/export/ror/clone/:id">
        {(params) => <BulkExportClone exportType="ror" clone={params.id} />}
      </Route>
      <Route path="/export/ror/:id">
        {(params) => <BulkExportDetail id={params.id} exportType="ror" />}
      </Route>

      {/* INFO */}
      <Route path="/info">
        <InfoPage />
      </Route>

      {/* API */}
      <Route path="/api">
        <ApiPage />
      </Route>

      <Route path="/import/:page">{(params) => <ImportPage page={params.page} />}</Route>
      <Route>
        <HomePage />
      </Route>
    </Switch>
  );
}
